import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Trophy } from "lucide-react";

export default function Contractors() {
  const { t } = useI18n();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="mono">Yüklənir...</div>;

  const sorted = [...stats.contractor_ratings].sort((a, b) => b.rating - a.rating);

  return (
    <div className="space-y-6">
      <div>
        <div className="label-overline mb-1">{t("contractors")}</div>
        <h1 className="font-heading font-black text-4xl tracking-tight">
          Podratçı Reytinqi
        </h1>
        <p className="text-slate-600 mt-2">OK / (OK + NOT OK) × 100%</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sorted.length === 0 && (
          <div className="col-span-full text-slate-500">{t("no_data")}</div>
        )}
        {sorted.map((c, i) => (
          <div
            key={c.contractor_id}
            className="bg-white border border-slate-200 rounded-lg p-5"
            data-testid={`contractor-${c.contractor_id}`}
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                {i === 0 && <Trophy className="w-4 h-4 text-amber-500" />}
                <span className="mono font-bold text-slate-400">
                  #{i + 1}
                </span>
              </div>
              <div className="mono text-2xl font-black">{c.rating}%</div>
            </div>
            <h3 className="font-heading font-bold text-lg">{c.name}</h3>
            <div className="text-xs text-slate-500 mb-3">{c.organization}</div>
            <div className="h-2 bg-slate-100 rounded">
              <div
                className="h-full bg-gradient-to-r from-emerald-400 to-emerald-600 rounded"
                style={{ width: `${c.rating}%` }}
              />
            </div>
            <div className="grid grid-cols-2 gap-2 mt-3 text-center">
              <div className="bg-emerald-50 text-emerald-700 rounded p-2">
                <div className="mono font-bold text-lg">{c.ok}</div>
                <div className="label-overline text-emerald-700">OK</div>
              </div>
              <div className="bg-red-50 text-red-700 rounded p-2">
                <div className="mono font-bold text-lg">{c.not_ok}</div>
                <div className="label-overline text-red-700">NOT OK</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
